const intercomConfigs = {
  app_id: process.env.REACT_APP_INTERCOM_APP_ID,
}

export const initIntercom = () => {
  window.Intercom('boot', {
    ...intercomConfigs,
    alignment: 'right',
  })
}

export const registerIntercomUser = (userAlias, userHash) => {
  window.Intercom('boot', {
    ...intercomConfigs,
    user_id: userAlias,
    user_hash: userHash,
    alignment: 'left',
  })
}

export const intercomSetLauncherVisibility = (isVisible) => {
  window.Intercom('update', { hide_default_launcher: !isVisible })
}

export const intercomShowMessenger = () => {
  window.Intercom('show')
}

export const intercomShowNewMessage = (message) => {
  window.Intercom('showNewMessage', message)
}

export const intercomShutdown = () => {
  window.Intercom('shutdown')
}

export const setUserId = () => {}
export const init = () => {}

export const sendEvent = (event, eventProperties) => {
  window.Intercom('trackEvent', event, eventProperties)
}

export const setUserProperties = (userProperties, state) => {
  const userHash = state.general.intercomUserHashWeb
  if (!userProperties.user_alias || !userHash) {
    return
  }
  const parsedUserProperties = Object.entries(userProperties).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: String(value) }),
    {},
  )

  const {
    // eslint-disable-next-line camelcase
    user_alias: userAlias,
    ...rest
  } = parsedUserProperties

  window.Intercom('update', {
    app_id: process.env.REACT_APP_INTERCOM_APP_ID,
    user_hash: userHash,
    user_id: userAlias,
    ...rest,
  })
}

export const startIntercomTour = (tourId) => {
  if (!tourId) {
    // eslint-disable-next-line no-console
    console.error(`[Intercom] startIntercomTour: Invalid tourId: ${tourId}`)
    return
  }
  window.Intercom('startTour', tourId)
}

export default {
  init,
  sendEvent,
  setUserProperties,
  setUserId,
}
